import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchText$ from '@atlassian/jira-fetch/src/utils/as-text-stream.tsx';

export const getRankAfterUrl = (baseUrl: string): string =>
	`${baseUrl}/rest/greenhopper/1.0/api/rank/after`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	customFieldId: number,
	issueIds: number[],
	rankAfterId: number,
): ObservableType<string | null> =>
	fetchText$(getRankAfterUrl(baseUrl), {
		method: 'PUT',
		body: JSON.stringify({
			customFieldId,
			issueIds,
			rankAfterId,
		}),
	});
